import { FC } from 'react';
import { Icon, Text } from '@livechat/design-system-react-components';
import { Warning as WarningIcon } from '@livechat/design-system-icons';

import { FormMessageType } from 'types/form';

import * as styles from './styles';

type Props = {
  type?: FormMessageType;
  children: React.ReactNode;
};

export const FormMessage: FC<Props> = ({ children, type }) => (
  <div
    css={[
      styles.formMessage,
      type === FormMessageType.Success && styles.messageSuccess,
      type === FormMessageType.Error && styles.messageError,
    ]}
    data-testid="form-message"
  >
    {type === FormMessageType.Error && (
      <div>
        <Icon kind="error" size="large" source={WarningIcon} css={styles.messageIconStyle} />
      </div>
    )}
    <Text>{children}</Text>
  </div>
);
